import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  vehicles: undefined,
  allVehicles: [],
  categories: [],
  err: undefined,
  vehicle: {},
  updating: false,
  creating: false,
  vehicelsLoading: true,
  distanceflat: 0,
  durationflat: 0,
};

const vehicleSlice = createSlice({
  name: "vehicle",
  initialState: initialState,
  reducers: {
    setDistance: (state, action) => {
      state.distanceflat = action.payload.distanceflat;
    },
    setDuration: (state, action) => {
      state.durationflat = action.payload.durationflat;
    },
    setVehicleIsLoading: (state, action) => {
      state.vehicelsLoading = action.payload.vehicelsLoading;
    },
    vehicleCreating: (state, action) => {
      state.creating = action.payload.creating;
    },
    getVehicles: (state, action) => {
      state.vehicles = action.payload.vehicle;
    },
    getCategories: (state, action) => {
      state.categories = action.payload.categories;
    },
    getAllVehicles: (state, action) => {
      state.allVehicles = action.payload.allVehicles;
    },
    getVehiclesErr: (state, action) => {
      state.err = action.payload.err;
    },
    getVehicle: (state, action) => {
      state.vehicle = action.payload.vehicle;
    },
    setUpdate: (state, action) => {
      state.updating = action.payload.updating;
    },
  },
});

export const {
  setDistance,
  setDuration,
  setVehicleIsLoading,
  getVehicles,
  getAllVehicles,
  getVehiclesErr,
  getVehicle,
  setUpdate,
  getCategories,
  vehicleCreating,
} = vehicleSlice.actions;
export const vehicleReducer = vehicleSlice.reducer;
